module.exports = __webpack_public_path__ + "img/shape-1.03cac921.svg";